let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
import { css, useTheme } from 'foundations-theming-specialty/utils';
// eslint-disable-next-line
import { isTrellisTheme } from 'foundations-theming/utils';
import styled from 'styled-components';
import { ExternalLinkIcon } from '../../../nav-ui-components/Icons/ExternalLink';
import { getSetUpDeployLink } from '../utils/urlHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledExternalLinkIcon = styled(ExternalLinkIcon).withConfig({
  displayName: "SetUpDeployLink__StyledExternalLinkIcon",
  componentId: "sc-8cri5c-0"
})(["margin-bottom:0px !important;width:10px !important;height:10px !important;"]);
const TrellisLightLinkStyles = css(({
  theme
}) => css(_t || (_t = _`
    background-color: ${0};
    border: 1px solid ${0} !important;
    &:hover {
      background-color: ${0};
    }
    &:active {
      background-color: ${0};
    }
  `), theme.color['fill-secondary-default'], theme.color['border-secondary-default'], theme.color['fill-secondary-hover'], theme.color['fill-secondary-pressed']));
const CanvasLightLinkStyles = css(({
  theme
}) => css(_t2 || (_t2 = _`
    background-color: ${0};
    border: 1px solid ${0} !important;
    &:hover {
      background-color: ${0};
    }
    &:active {
      background-color: ${0};
    }
  `), theme.color['fill-tertiary-default'], theme.color['border-tertiary-default'], theme.color['fill-tertiary-hover'], theme.color['fill-tertiary-pressed']));
const StyledLink = styled.a.withConfig({
  displayName: "SetUpDeployLink__StyledLink",
  componentId: "sc-8cri5c-1"
})(({
  theme,
  isTrellis
}) => css(_t3 || (_t3 = _`
    border-radius: ${0} !important;
    padding: ${0} !important;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    transition: all 150ms ease-out;
    white-space: nowrap;
    text-decoration: none !important;
    color: ${0};
    ${0}
  `), theme.borderRadius['100'], `${theme.space['100']} ${theme.space['300']}`, theme.color['text-core-default'], isTrellis ? TrellisLightLinkStyles : CanvasLightLinkStyles));
const StyledLinkText = styled.span.withConfig({
  displayName: "SetUpDeployLink__StyledLinkText",
  componentId: "sc-8cri5c-2"
})(({
  theme,
  isTrellis
}) => css(_t4 || (_t4 = _`
    display: inline-flex;
    align-items: center;
    ${0};
    text-decoration: none;
    ${0}
  `), theme.typography['detail-100'], isTrellis ? `color: ${theme.color['text-core-default']};` : `color: ${theme.color['text-tertiary-default']};`));
/**
 * @param parentHubId - The parent hub ID
 * @param sandboxHubId - The sandbox hub ID
 * @returns A link styled as a button that will navigate to the sandbox deploy
 * setup page within the parent hub on clicks
 */
export function SetUpDeployLink({
  parentHubId,
  sandboxHubId
}) {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const setUpDeployLink = getSetUpDeployLink({
    parentHubId,
    sandboxHubId
  });
  if (!sandboxHubId || !parentHubId || !setUpDeployLink) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledLink, {
    href: setUpDeployLink,
    target: "_blank",
    rel: "noopener noreferrer",
    isTrellis: isTrellis,
    "data-test-id": "set-up-deploy-link",
    children: /*#__PURE__*/_jsxs(StyledLinkText, {
      isTrellis: isTrellis,
      children: ["Set up a deploy", /*#__PURE__*/_jsx(StyledExternalLinkIcon, {
        fill: theme.color['text-core-default']
      })]
    })
  });
}